module.exports = __webpack_public_path__ + "static/media/video.b505d7c7.svg";